<template>
    <div class="container pt-2">
        <PageTitle main="Relatório de Registro de Transportes" sub="" />
        <div class="row">
            <div class="col-md-12">
                <b-form-group label="Código de Rastreio:" label-for="rep-transporte">
                    <b-form-select id="rep-transporte" :options="transportes"
                        v-model="rep.rastreio"
                        placeholder="Informe o código de rastreio."
                        @change="loadLogs"
                        class="textInput"/>
                </b-form-group>
            </div>
        </div>
        <div class="row justify-content-md-center" v-if="isLoading">
            <b-spinner variant="success" label="Spinning"></b-spinner>
        </div>
        <b-button variant="success" block class="mt-2 mb-2 botaoInput" @click="callReport" v-if="!visualizaReport && !isLoading">Gerar Relatório</b-button>
        <hr v-if="!visualizaReport">
        <b-button variant="warning" block class="mt-2 mb-2 botaoInput" :href="link" v-if="visualizaReport">Salvar</b-button>
        <hr v-if="visualizaReport">
        <div :style="{ overflow: overflowValue, width: larguraTela + 'px' }" v-if="larguraTela<721">
            <b-table 
                hover 
                striped 
                id="table-logs" 
                class="text-center table table-sm" 
                :items="logs.length>0?logs:[]" 
                :fields="fields">
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
        </div>
        <div v-else>
            <b-table 
                hover 
                striped 
                id="table-logs" 
                class="text-center table table-sm" 
                :items="logs.length>0?logs:[]" 
                :fields="fields" >
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'

export default {
    name: 'LogTransportes',
    components: { PageTitle },
    data: function() {
        return {
            larguraTela: 0,
            overflowValue: 'auto',
            visualizaReport: false,
            isLoading: false,
            link: '',
            transporte: {},
            transportes: [],
            rep: {},
            exibeRodape: true,
            logs: [],
            fields: [
                { key: 'transporte', label: 'Rastreio', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'status', label: 'Status', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'data', label: 'Data', sortable: true, formatter: 'formatData', thClass: 'tituloTabela', tdClass: 'fieldsTabela' }
            ]
        }
    },
    methods: {
        formatData(value) {
            const arr = value.split('-')
            const y = arr[0]
            const m = arr[1]
            const d = arr[2]
            return `${d}/${m}/${y}`
        },
        loadLogs() {
            const url = `${baseApiUrl}/backend/logByRastreio.php?rastreio=${this.rep.rastreio}`
            axios.get(url).then(res => {
                this.logs = res.data
                if(this.logs.length > 0) {
                    this.exibeRodape = false
                }else{
                    this.exibeRodape = true
                }
            })
        },
        callReport() {
            this.isLoading = true
            const url = `${baseApiUrl}/backend/repLogTransportes.php?rastreio=${this.rep.rastreio}`
            axios.get(url).then((res) => {
                this.isLoading = false
                this.visualizaReport = true
                this.link = res.data['result']
            })
        },
        loadTransportes() {
            const url = `${baseApiUrl}/backend/transportes.php`
            axios.get(url).then(res => {
                if(res.data['dados']!=='Não há dados disponíveis'){
                    this.transportes = res.data.map(transporte => {
                        return { ...transporte, value: transporte.rastreio, text: transporte.rastreio }
                    })
                }else{
                    this.transportes.push({ value: 'null', text: 'Não há dados disponíveis' })
                }
            })
        }
    },
    mounted() {
        this.loadTransportes()

        this.visualizaReport = false
        this.larguraTela = screen.width - (screen.width * 0.08)
    }
}
</script>

<style>
</style>